export default __webpack_public_path__ + "static/media/6.d28e0f42.png";